import { Gender } from "@/interfaces";
import httpClient, { ApiResponse } from "@/api/httpClient";

export const getAllGenders = async (): Promise<ApiResponse<Gender>> =>
  await httpClient.get(`/genders`);
